import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

// Schema: SurveyForm (verified against SCHEMA_REFERENCE.json). Questions are
// JSON-serialized (QuestionsJson). Sectioned forms are supported by the
// schema (HasSections + SectionsJson) even though this module's editor UI
// only authors flat (unsectioned) forms for now — see survey-form.types.ts.
/** Latest change first by default, like the old `GetSurveyForms` `{ LastUpdateDate: -1 }` sort. */
export const DEFAULT_SURVEY_FORMS_ORDER: OrderBy[] = [
  { field: 'LastUpdatedDate', direction: 'DESC' },
];

export const buildGetSurveyFormsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_SURVEY_FORMS_ORDER
) => `
  query {
    SurveyForms: getSurveyForms(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        Title
        Description
        HasSections
        QuestionsJson
        SectionsJson
      }
    }
  }
`;
